import { render, staticRenderFns } from "./BankAcctDet.vue?vue&type=template&id=3f06dd2b&"
import script from "./BankAcctDet.vue?vue&type=script&lang=js&"
export * from "./BankAcctDet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports